import type { Page, PageableInfoNew, Vod } from '@setplex/tria-api'

import { api } from '@setplex/tria-api'
import { combine, createEvent, createStore } from 'effector'
import { model as i18n } from '~/core/i18n'
import { genPagesLogicNew } from '~/shared/effector'
import { extendMediaItemByLabelPrice } from '~/shared/tools'

export const resetPurchasedVodsRow = createEvent()
export const $purchasedVodsRow = createStore<Page<Vod> | null>(null)
  .on(api.vods.getPurchasedVodsRowFx.doneData, (_, page) => page)
  .reset(resetPurchasedVodsRow)

export const $purchasedVodsRowFormatted = combine(
  $purchasedVodsRow,
  i18n.$t,
  (purchasedVodsRow) => ({
    ...purchasedVodsRow,
    content: purchasedVodsRow?.content.map((item) =>
      extendMediaItemByLabelPrice(item)
    ),
  })
)

export const resetPurchasedVodsGrid = createEvent()
export const $purchasedVodsGrid = createStore<Page<Vod> | null>(null)
  .on(api.vods.getPurchasedVodsGridFx.doneData, (state, page) => {
    const currentVods = state
      ? [...state.content, ...page.content]
      : page.content

    return {
      ...page,
      content: currentVods,
    }
  })
  .reset(resetPurchasedVodsGrid)

export const $purchasedVodsGridFormatted = combine(
  $purchasedVodsGrid,
  i18n.$t,
  (purchasedVodsGrid) => {
    const formattedPageContent = purchasedVodsGrid?.content.map((item) =>
      extendMediaItemByLabelPrice(item)
    )

    return {
      ...purchasedVodsGrid,
      content: formattedPageContent,
    }
  }
)

export const loadMorePurchasedVodsGrid = genPagesLogicNew(
  $purchasedVodsGrid.map((state) => {
    if (!state) return null

    const { last, first, number, size } = state
    const pageableInfo: PageableInfoNew = {
      last,
      first,
      number,
      size,
    }
    return pageableInfo
  }),
  api.vods.getPurchasedVodsGridFx
)
